import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PayBalance from '../components/PayBalance';
import { bindActionCreators } from 'redux';
import { cancelAll } from '../../../data/followup/actions/followup';

class PayBalanceContainer extends Component {
    static propTypes = {
        cancelAll: PropTypes.func
    };

    handleCancel() {
        this.props.cancelAll();
    }

    render() {
        return (
            <PayBalance
                onCancel={::this.handleCancel}
            />
        );
    }
}

export default connect(
    null,
    dispatch => bindActionCreators({ cancelAll }, dispatch)
)(PayBalanceContainer);
